import type { FeatureFlagBusinessMutationRequestType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request } from "../apiV2Request";
import { trpc } from "../trpc";

export const useAdminFeatureFlagBusinessEnable = (featureFlagId: number) => {
  const queryClient = useQueryClient();
  const trpcUtils = trpc.useUtils();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () => {
      const data: FeatureFlagBusinessMutationRequestType = {
        businessId: business?.id ?? 0,
      };
      return apiV2Request({
        user,
        business,
        method: "post",
        path: `feature-flags/${featureFlagId}/business`,
        data,
      });
    },
    onSuccess: () =>
      Promise.all([
        trpcUtils.featureFlag.list.invalidate(),
        queryClient.invalidateQueries({
          queryKey: ["feature-flags", "admin", business?.id],
        }),
      ]),
  });
};
